import { Shell, Ctas, Credits, Note } from "../shared";

export const LetterPage = ({ page }) => (
  <Shell page={page}>
    <div className="absolute left-11 right-11" style={{ top: 70, bottom: 60 }}>
      <div className="mag-kicker" style={{ color: "var(--bordeaux)" }}>{page.kicker}</div>
      <h2 className="mag-head mt-3" style={{ fontSize: 40 }}>{page.title}</h2>
      <div className="silver-rule-solid my-5" />
      <div className="mag-body" style={{ maxWidth: 440 }}>
        {page.body.map((p, i) => <p key={i} className={i === 0 ? "first-letter:font-head first-letter:text-[44px] first-letter:float-left first-letter:mr-2 first-letter:leading-[0.8] first-letter:text-[var(--bordeaux)]" : ""}>{p}</p>)}
      </div>
      {page.quote && <p className="mag-quote mt-6">{page.quote}</p>}
      <div className="absolute bottom-0 left-0 right-0">
        <div className="silver-rule-solid mb-3" />
        <Credits page={page} className="grid grid-cols-2 gap-x-6" />
      </div>
    </div>
  </Shell>
);

export const OpenerPage = ({ page }) => (
  <Shell page={page}>
    <div className="absolute left-11 right-11" style={{ top: 96 }}>
      <div className="mag-kicker" style={{ color: "var(--bordeaux)" }}>{page.kicker}</div>
      <h2 className="mag-head uppercase mt-6" style={{ fontSize: 62, letterSpacing: "-0.02em" }}>{page.title}</h2>
      <div className="silver-rule-solid my-6" />
      <p className="mag-deck" style={{ fontSize: 20, maxWidth: 460 }}>{page.deck}</p>
      <div className="mag-body mt-6" style={{ maxWidth: 420 }}>
        {page.body?.map((p, i) => <p key={i}>{p}</p>)}
      </div>
      <Credits page={page} className="mt-6" />
      <Note page={page} className="mt-4" />
    </div>
  </Shell>
);

export const ArticlePage = ({ page }) => (
  <Shell page={page}>
    <div className="absolute left-11 right-11" style={{ top: 64, bottom: 56 }}>
      {page.image && (
        <div style={{ height: 200, overflow: "hidden", marginBottom: 18 }}>
          <img src={page.image} alt={page.title} className="mag-img" />
        </div>
      )}
      <div className="mag-kicker" style={{ color: "var(--bordeaux)" }}>{page.kicker}</div>
      <h2 className="mag-head mt-2" style={{ fontSize: page.image ? 30 : 38 }}>{page.title}</h2>
      {page.deck && <p className="mag-deck mt-2" style={{ opacity: 0.85 }}>{page.deck}</p>}
      <div className="silver-rule-solid my-4" />
      <div className={`mag-body ${page.body.length > 2 ? "mag-cols" : ""}`}>
        {page.body.map((p, i) => <p key={i}>{p}</p>)}
      </div>
      {page.quote && (
        <div className="mt-5 pl-4" style={{ borderLeft: "2px solid var(--bordeaux)" }}>
          <p className="mag-quote" style={{ fontSize: 19 }}>“{page.quote}”</p>
          {page.quote_by && <p className="mag-kicker mt-2" style={{ fontSize: 8 }}>— {page.quote_by}</p>}
        </div>
      )}
      <Ctas page={page} className="mt-5" />
      <div className="absolute bottom-0 left-0 right-0">
        <Credits page={page} />
        <Note page={page} className="mt-2" />
      </div>
    </div>
  </Shell>
);

export const ClosingPage = ({ page }) => (
  <Shell page={page}>
    <div className="absolute left-11 right-11" style={{ top: 120 }}>
      <div className="mag-kicker" style={{ color: "var(--bordeaux)" }}>{page.kicker}</div>
      <h2 className="mag-head mt-4" style={{ fontSize: 50 }}>{page.title}</h2>
      <div className="silver-rule-solid my-6" />
      <div className="mag-body" style={{ maxWidth: 420, fontSize: 13.5 }}>
        {page.body.map((p, i) => <p key={i}>{p}</p>)}
      </div>
      <Ctas page={page} className="mt-8" />
      <div className="mt-16">
        <div className="glass-text" data-text="ROOTS" style={{ fontSize: 96, filter: "drop-shadow(0 6px 16px rgba(0,0,0,0.25))" }}>ROOTS</div>
        <Credits page={page} className="mt-4" />
      </div>
    </div>
  </Shell>
);
